import script from "./AutoAllocConsoleHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAllocConsoleHistory.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAllocConsoleHistory.vue?vue&type=style&index=0&id=63e46640&scoped=true&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e46640"]])

export default __exports__